import React from 'react';
import PropTypes from 'prop-types';
//import styled from "src/common-ui/styled";
import ButtonBase from './ButtonBase';

export class ButtonComponent extends React.Component {
  static propTypes = {
    disabled: PropTypes.bool,
    onClick: PropTypes.func,
    styleType: PropTypes.string,
    noMaxWidth: PropTypes.bool,
    isLoading: PropTypes.bool,
  };

  static defaultProps = {
    disabled: false,
    styleType: 'default',
    noMaxWidth: false,
    isLoading: false,
  };

  getStyles = type => {
    switch (type) {
      case 'primary':
        return {
          root: {},
        };

      case 'secondary':
        return {
          root: {
            backgroundColor: '#FFF',
            border: '1px solid #2E2E38',
            color: '#2E2E38',
            '&:hover': {
              border: 'solid 1px #2E2E38',
              backgroundColor: '#F6F6FA',
              boxShadow: '0 0 4px 0 rgba(0,0,0,0.66)',
            },
          },
          label: {
            color: '#2E2E38',
            fontWeight: 'bold',
            fontSize: '14px',
          },
          labelDisabled: {
            color: '#C4C4CE',
            fontWeight: 'bold',
            fontSize: '14px',
          },
          disabled: {
            backgroundColor: '#EAEAF2',
            border: 'solid 1px #EAEAF2',
          },
        };

      case 'secondary-short':
        return {
          root: {
            backgroundColor: '#FFF',
            border: '1px solid #2E2E38',
            color: '#2E2E38',
            height: '44px',
            '&:hover': {
              border: 'solid 1px #2E2E38',
              backgroundColor: '#F6F6FA',
              boxShadow: '0 0 4px 0 rgba(0,0,0,0.66)',
            },
          },
          label: {
            color: '#2E2E38',
            fontWeight: 'bold',
            fontSize: '14px',
          },
          labelDisabled: {
            color: '#C4C4CE',
            fontWeight: 'bold',
            fontSize: '14px',
          },
          disabled: {
            backgroundColor: '#EAEAF2',
            border: 'solid 1px #EAEAF2',
          },
        };

      case 'tertiary':
        return {
          root: {
            backgroundColor: '#FFF',
            border: '1px solid rgba(196,196,205,0.35)',
            color: '#2E2E38',
            '&:hover': {
              border: 'solid rgba(196,196,205,0.35)',
              backgroundColor: '#FFF',
              boxShadow: 'none',
            },
          },
          label: {
            color: '#2E2E38',
            fontWeight: 'bold',
            fontSize: '14px',
          },
          labelDisabled: {
            color: '#C4C4CD',
            fontWeight: 'bold',
            fontSize: '14px',
          },
          disabled: {
            backgroundColor: 'rgba(196,196,205,0.35)',
            border: 'solid 1px rgba(196,196,205,0.35)',
          },
        };

      case 'login':
        return {
          root: {
            '&:hover': {
              boxShadow: 'none',
            },
          },
          disabled: {
            backgroundColor: 'rgb(93,93,102)',
            color: '#C4C4CD',
            '&:hover': {
              backgroundColor: 'inherit',
              color: 'inherit',
              boxShadow: 'none',
              border: 'inherit',
            },
          },
        };

      case 'cancel':
        return {
          root: {
            backgroundColor: '#2E2E38',
            borderRadius: 0,
            border: '1px solid #fff',
            color: '#fff',
            '&:hover': {
              border: `1px solid #fff`,
              backgroundColor: '#2E2E38',
              boxShadow: '0 0 4px 0 rgba(255,230,0,0.66)',
            },
          },
          label: {
            color: '#fff',
            fontWeight: 'bold',
            fontSize: '14px',
            textTransform: 'capitalize',
          },
        };
      case 'icon':
        return {
          root: {
            backgroundColor: '#fff',
            borderRadius: 90,
            border: 0,
            width: 0,
            height: 0,
            maxWidth: 0,
            minWidth: 40,
            padding: 0,
            color: '#000',
            '&:hover': {
              border: 'none',
              backgroundColor: '#ddd',
              boxShadow: '0',
            },
          },
          label: {
            color: '#000',
            fontWeight: 'bold',
            fontSize: '14px',
            textTransform: 'capitalize',
          },
        };
      case 'blue-button':
        return {
          root: {
            backgroundColor: '#F6F5FA',
            border: 0,
            width: 0,
            height: 0,
            padding: 0,
            margin: '10px 0',
            '&:hover': {
              border: 'none',
              backgroundColor: '#ddd',
              boxShadow: '0',
            },
          },
          label: {
            color: '#188BE5',
            fontWeight: 'bold',
            fontSize: '12px',
            textTransform: 'capitalize',
            position: 'relative',
            justifyContent: 'flex-start',
            display: 'flex',
            // color: '#188BE5',
            // fontWeight: 'bold',
            // fontSize: '12px',
            // textTransform: 'capitalize',
            // position: 'relative',
            // left: '-5px',
          },
        };
      case 'back-button':
        return {
          root: {
            backgroundColor: 'transparent',
            border: 0,
            width: 0,
            height: 0,
            padding: 0,
            margin: '10px 0',
            '&:hover': {
              border: 'none',
              boxShadow: '0',
            },
          },
          label: {
            color: '#2E2E38',
            fontFamily: 'EYInterstate Light',
            fontSize: '.9rem',
            position: 'relative',
            justifyContent: 'flex-start',
            display: 'flex',
          },
        };
      case 'down-button':
        return {
          root: {
            backgroundColor: '#fff',
            border: '1px solid #aaa',
            height: 0,
            width: 10,
            minHeight: '25px',
            padding: 0,
            minWidth: '25px',
            margin: '10px 0px',
            '&:hover': {
              backgroundColor: '#ddd',
              boxShadow: '0',
            },
          },
          label: {
            color: '#000000',
            fontWeight: 'bold',
            fontSize: '12px',
            textTransform: 'capitalize',
          },
        };
      case 'cmsUpload':
        return {
          root: {
            padding: '0',
            maxWidth: '197px',
            height: '43px',
          },
        };
      case 'engagementTeamadd':
        return {
          root: {
            padding: '0',
            width: '225px',
            maxWidth: '2225px',
            minWidth: '225px',
            height: '45px',
          },
        };
      case 'addNewengagements':
        return {
          root: {
            padding: '0',
            maxWidth: '197px',
            height: '43px',
            textAlign: 'right',
          },
        };
      case 'addNewengagementsUser':
        return {
          root: {
            padding: '0',
            width: '194px',
            maxWidth: '202px',
            minWidth: '194px',
            height: '43px',
            textAlign: 'right',
          },
        };
      case 'transparent-button':
        return {
          root: {
            color: '#000000',
            fontWeight: 'bold',
            border: 'none',
            cursor: 'pointer',
            height: '44px',
            backgroundColor: 'transparent',
            '&:hover': {
              border: 'none',
              backgroundColor: 'transparent',
              boxShadow: '0',
            },
          },
        };

      case 'down-arrow-button':
        return {
          root: {
            backgroundColor: '#fff',
            height: 0,
            width: 10,
            minHeight: '25px',
            padding: 0,
            minWidth: '25px',
            margin: '10px 0px',
            '&:hover': {
              backgroundColor: '#fff',
              boxShadow: '0',
              outline: 'none',
            },
          },
          label: {
            color: '#000000',
            fontWeight: 'bold',
            fontSize: '12px',
            textTransform: 'capitalize',
          },
        };

      case 'case-selection-button':
        return {
          root: {
            height: '18px',
            width: '70.63px',
            borderRadius: '9px',
            backgroundColor: '#2E2E38',
            '&:hover': {
              backgroundColor: '#2E2E38',
              boxShadow: '0',
              outline: 'none',
              border: 'none',
            },
          },
          label: {
            color: '#FFFFFF',
            fontWeight: 'bold',
            fontSize: '10px',
            textTransform: 'capitalize',

            height: '12px',
            width: '71.63px',
            //fontFamily: EYInterstate,
            lineHeight: '12px',
            textAlign: 'center',
          },
        };
      case 'outline-button':
        return {
          root: {
            color: '#FFF',
            fontWeight: 'bold',
            border: `1px solid #fff`,
            cursor: 'pointer',
            backgroundColor: 'transparent',
            '&:hover': {
              border: `1px solid #fff`,
              backgroundColor: 'rgba(255, 255, 255, 0.25)',
              boxShadow: '0',
            },
          },
          label: {
            color: '#FFF',
            fontWeight: 'bold',
            fontSize: '14px',
          },
          labelDisabled: {
            color: '#747480',
            fontWeight: 'bold',
            fontSize: '14px',
          },
          disabled: {
            backgroundColor: 'transparent',
            border: 'solid 1px #747480',
          },
        };
      default:
        return {};
    }
  };

  render() {
    const { styleType, ...otherProps } = this.props;
    const styles = this.getStyles(styleType);

    return <ButtonBase styles={styles} {...otherProps} />;
  }
}

export default ButtonComponent;
